var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-top"}},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"page-title-en"},[_vm._v(_vm._s(_vm.en))])])
}
var staticRenderFns = []

export { render, staticRenderFns }